import { SVGProps } from 'react';

const ExclamationIcon = (
  props: SVGProps<SVGSVGElement> & { iconColor?: string },
) => {
  const { iconColor, ...rest } = props;
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_1456_132115)'>
        <path
          d='M7.38506 10.3332C7.38506 10.5669 7.30006 10.7794 7.14068 10.9388C6.98131 11.0982 6.75818 11.1832 6.53506 11.1832C6.31193 11.1832 6.08881 11.0982 5.92943 10.9388C5.77006 10.7794 5.68506 10.5669 5.68506 10.3332C5.68506 10.0994 5.77006 9.89753 5.92943 9.73815C6.08881 9.57878 6.31193 9.48315 6.53506 9.48315C6.75818 9.48315 6.98131 9.57878 7.14068 9.73815C7.30006 9.89753 7.38506 10.11 7.38506 10.3332Z'
          fill={iconColor || '#C6782E'}
        />
        <path
          d='M7.38506 3.53311V6.93311C7.38506 7.16686 7.30006 7.37936 7.14068 7.53873C6.98131 7.69811 6.75818 7.78311 6.53506 7.78311C6.31193 7.78311 6.08881 7.69811 5.92943 7.53873C5.77006 7.37936 5.68506 7.16686 5.68506 6.93311V3.53311C5.68506 3.30998 5.77006 3.09748 5.92943 2.93811C6.08881 2.77873 6.31193 2.68311 6.53506 2.68311C6.75818 2.68311 6.98131 2.77873 7.14068 2.93811C7.30006 3.09748 7.38506 3.30998 7.38506 3.53311Z'
          fill={iconColor || '#C6782E'}
        />
      </g>
      <defs>
        <clipPath id='clip0_1456_132115'>
          <rect
            width='1.7'
            height='8.5'
            fill='white'
            transform='translate(5.68506 2.68311)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExclamationIcon;
